import React from 'react'
import PropTypes from 'prop-types'
import { Button, makeStyles } from '@material-ui/core'
import Icon from '../../../../components/atoms/Icon'
import { getAttachmentIcon, getAttachmentPreviewText } from '../utils/attachmentUtils'
import FlexColumn from '../../../../components/molecules/FlexColumn'

const useStyles = makeStyles((theme) => ({
  attachmentButton: {
    justifyContent: 'flex-start',
    textTransform: 'none',
    backgroundColor: 'var(--dai-color-surface2)',
    fontSize: 'var(--font-size-xs)',
    color: 'var(--dai-color-text)',
    border: 'var(--dai-border1)',
    paddingRight: 'var(--padding-lg)',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: 'var(--dai-color-surface-highlight)',
      borderColor: 'var(--dai-color-border-accent-hl)',
      '& .attachment-icon': {
        fill: 'var(--dai-color-accent)'
      },
      '& $titleText': {
        color: 'var(--dai-color-accent)'
      },
      '& $previewText': {
        color: 'var(--dai-color-accent-low)'
      }
    }
  },
  titleText: {
    textOverflow: 'ellipsis',
    overflowX: 'hidden',
    whiteSpace: 'nowrap',
    maxWidth: '600px',
    fontFamily: 'var(--font-serif)',
    fontSize: 'var(--font-size-sm)',
    marginBottom: 'calc(var(--dim-1) * -1)'
  },
  previewText: {
    color: 'var(--dai-color-text-low)',
    // marginLeft: 'var(--dim-2)',
    fontSize: 'var(--font-size-xs)',
    textOverflow: 'ellipsis',
    overflowX: 'hidden',
    whiteSpace: 'nowrap',
    maxWidth: '600px'
  }
}))

function AttachmentButton ({ onOpen, attachment }) {
  const classes = useStyles()

  return (
    <Button
      className={classes.attachmentButton}
      size='small'
      variant='outlined'
      onClick={() => onOpen?.(attachment)}
      startIcon={
        <div className='flex justify-center items-center' style={{ marginTop: '-2px', marginLeft: 'var(--dim-2)', marginRight: 'var(--dim-2)' }}>
          <Icon
            additionalClasses='attachment-icon'
            name={getAttachmentIcon(attachment.contentType)}
            customSize={32}
          />
        </div>
      }
    >
      <FlexColumn className='justify-start text-left items-start mt-1 mb-1 mr-3' style={{ gap: 0 }}>
        <span className={classes.titleText}>{attachment.title}</span>
        <span className={classes.previewText}>
          {getAttachmentPreviewText(attachment)}
        </span>
      </FlexColumn>
    </Button>
  )
}

AttachmentButton.propTypes = {
  onOpen: PropTypes.func,
  attachment: PropTypes.object
}

export default AttachmentButton
